import { useEffect, useLayoutEffect, useState } from 'react';

import { TermsPolicy } from 'pages/public/components/common';
import { useSearchParams } from 'react-router-dom';
import { cn } from 'utils/helpers';

import { useVerifyOtp } from '../../hooks';
import PublicWrapper from '../PublicWrapper';
import Form from './Form';
import Success from './Success';

export default function ForgotPassword() {
  const { mutate: verifyOtp, data } = useVerifyOtp();
  const [emailAddress, setEmailAddress] = useState<null | string>(null);
  const [requested, setRequested] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (data && data?.message === 'OTP verified.') {
      setRequested(true);
    }
  }, [data]);

  useLayoutEffect(() => {
    const _emailAddress = searchParams.get('emailAddress');
    const otp = searchParams.get('otp');
    const referenceId = searchParams.get('id');

    if (otp && referenceId && _emailAddress) {
      setEmailAddress(_emailAddress);
      verifyOtp({
        type: 'FORGOT_PASSWORD',
        source: 'account',
        referenceId,
        otp,
      });
    }
  }, [searchParams, verifyOtp]);

  return (
    <PublicWrapper
      className={cn(
        'h-screen w-screen p-4',
        'flex flex-col items-center justify-center',
        'text-sm text-secondary-base',
      )}
    >
      {!requested ? (
        <Form setRequested={setRequested} setEmailAddress={setEmailAddress} />
      ) : (
        <Success emailAddress={emailAddress ?? ''} />
      )}
      <TermsPolicy />
    </PublicWrapper>
  );
}
